import { createFileRoute } from "@tanstack/react-router";
import { ThreadsPage } from "@/features/threads/components/ThreadsPage";

export const parseFavoritesSearch = (search: Record<string, unknown>) => {
  const thread = Number(search.thread);
  return Number.isSafeInteger(thread) && thread > 0 ? { thread } : {};
};

export const Route = createFileRoute("/favorites")({
  validateSearch: parseFavoritesSearch,
  component: () => <ThreadsPage view="favorites" />,
});
